<template>
  <div id="app">
<!--    <img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@font-face {
  font-family: 'FZXB'; /* 设置字体名称 */
  src: url('/assets/fonts/FZXBSJW.TTF'); /* 设置字体文件路径 */
}
html,body{
  height: 100%;
  margin: 0;
  padding: 0;
  /*background-color: #EEEEEE;*/
}
/*body{*/
/*  background-color: #f6f6f6;*/
/*}*/
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  font-family: "Microsoft YaHei";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  height: 100%;
  /*margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue